import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";
import { observeResource } from "kea-resource";
import { createSelectorRx } from "keautils";

import { ColoniaFiltroComponent } from "./filtro";

type Entity = models.ColoniaDTO;
import { columnas } from "./columns";
const resource = resources.Colonia;

interface State {
    filtro: models.FiltroColonia;
}

interface props {
}

export class DireccionColoniaList extends React.PureComponent<props, State> {

    constructor(props) {
        super(props);
        this.state = { filtro: {} };
    }

    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar la colonia?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.query, filtro));

    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this);
        const items = this.items(this.state);
        return (
            <div>
                <kea.Title titulo="Colonia" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <ColoniaFiltroComponent value={this.state.filtro} onChange={filtro => this.setState({ filtro })} />

                <kea.Grid2 columnas={cols} cookieKey={"ColoniaListCookieKey"} items={items} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionColonia/list/list.tsx